import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    addToVersionStack: string;
    addToVersionStackTooltip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the button to add the export to a version stack */
            addToVersionStack: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "VersionStackToggleRow.addToVersionStack?c=3cnnbo2bawrp8", defaultMessage: "Add to Version Stack" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text for the "Add to Version Stack" option */
            addToVersionStackTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "VersionStackToggleRow.addToVersionStackTooltip?c=1yntj1z2pes6s", defaultMessage: "Uploads to a Version Stack, grouping it with previous exports." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
